import React from 'react';
import Link from '@/components/atoms/link';
import { AnnouncementBarProps } from './types';

const BAR_CLASSNAME = 'relative flex h-10 w-full items-center justify-center bg-gray-700';

const AnnouncementBar = ({ textBar, visibleBar = true, urlBar }: AnnouncementBarProps) => {
  if (!visibleBar) return null;

  const text = <p className="text-14 text-white">{textBar}</p>;

  if (urlBar) {
    return (
      <Link href={urlBar} block underlineOnHover={false} className={BAR_CLASSNAME}>
        {text}
      </Link>
    );
  }

  return <div className={BAR_CLASSNAME}>{text}</div>;
};

export default AnnouncementBar;
